import React, { useEffect, useState, useCallback } from 'react';

import './AthletePanel.scss';
import { useMsal } from "@azure/msal-react";

import { withLoadPanel } from '../../../utils/withLoadPanel';

import { AthletePanelDetails } from './AthletePanelDetails';
import { getApiToken } from '../../../utils/authUtils.js';
import { createStore } from 'devextreme-aspnet-data-nojquery';

const AthletePanelWithLoadPanel = withLoadPanel(AthletePanelDetails);

export const AthletePanel = ({ athleteId, isOpened, changePanelOpened, changePanelPinned }) => {
  const { instance, accounts } = useMsal();

  const [data, setData] = useState();

  const loadData = useCallback(() => {
    if (!athleteId) return;
    getApiToken(instance, accounts).then(token => {
      const dataSource = createStore({
        key: 'athleteId',
        loadUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/Athletes`,
        insertUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/InsertAthlete`,
        updateUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/UpdateAthlete`,
        deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/DeleteAthlete`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            'Authorization': "Bearer " + token
          };
        },
      });

      dataSource.load({ filter: ['athleteId', '=', athleteId] }).then(data => {
        setData(data[0])
      })

    })

  }, [athleteId]);

  const onDataChanged = useCallback(data => {
    setData(data);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <AthletePanelWithLoadPanel
      key={data?.athleteId}
      athlete={data}
      hasData={!!data}
      isOpened={isOpened}
      onDataChanged={onDataChanged}
      changePanelOpened={changePanelOpened}
      changePanelPinned={changePanelPinned}
      panelProps={{
        position: { of: '.panel' },
        container: '.panel'
      }}
    />
  );
};



